<script lang="ts" setup>
/**
 * Post-gate app host: Nuxt layout (miniapp/default/profile) + page.
 * Chrome (tab bar, Main/Back) lives in MiniAppChrome via layouts.
 * On mount: apply launch startParam once per session
 * (payment return → order detail; product_ → PDP).
 */
import { useStartParamLaunch } from '#Platform/composables/useStartParamLaunch'

const { applyLaunchStartParam } = useStartParamLaunch()

onMounted(() => {
  applyLaunchStartParam()
})
</script>

<template lang="html">
  <NuxtLayout>
    <slot />
  </NuxtLayout>
</template>
